import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

// 사전예약 신청
export const add = params => {
  console.log('add API');
  return ApiService.post(`preReservation`, params);
};

// 사전예약 조회 (하나씩 조회)
export const getById = params => {
  return ApiService.query(`preReservation/${params.id}`);
};

// 사전예약 리스트
export const getList = params => {
  console.log('getList API');
  return ApiService.query(`preReservation/me`);
};

// 사전예약 수정
export const modifyById = params => {
  console.log('modifyById API');

  return ApiService.put(`preReservation/${params.id}`, params);
};

// 사전예약 삭제 (삭제 - 사용안함)
export const removeById = params => {
  return ApiService.delete(`preReservation/${params.id}`);
};
